// extracted by mini-css-extract-plugin
module.exports = {"description":"style-module_description__26p0f2lZsAEYs_WMiLMaoJ"};